import Swiper, { FreeMode } from "swiper"

export default class MarqueeSlider {
  constructor(el) {
    this.el = el
    this.slider = null
    this.wrapper = this.el.querySelector('.swiper-wrapper')
    this.speed = 0.7
    this.currentX = 0
    this.raf = null
    this.isPaused = false
    this.reverse = this.el.hasAttribute('data-reverse')
    this.loopWidth = 0
    this.originalSlides = []
    this.offset = 0
    this.onResize = this.onResize.bind(this)
  }

  init() {
    this.originalSlides = Array.from(this.wrapper.children).map(slide => slide.cloneNode(true))
    this.cloneSlides()
    this.initSlider()
    this.applyTransform()
    this.animate()
    this.bindImagesLoad()
    window.addEventListener('resize', this.onResize, { passive: true })
  }

  cloneSlides() {
    const containerWidth = this.el.offsetWidth
    const slides = this.originalSlides.length
      ? this.originalSlides
      : Array.from(this.wrapper.children)

    // Build symmetrical sequence: [left clones][original][right clones]
    this.wrapper.innerHTML = ''
    slides.forEach(slide => this.wrapper.appendChild(slide.cloneNode(true)))
    this.loopWidth = this.wrapper.scrollWidth

    const leftClone = slides.map(slide => slide.cloneNode(true))
    leftClone.reverse().forEach(cloneEl => this.wrapper.prepend(cloneEl))
    let contentWidth = this.wrapper.scrollWidth

    const minContentWidth = containerWidth + this.loopWidth * 2
    while (contentWidth < minContentWidth) {
      const clone = slides.map(slide => slide.cloneNode(true))
      clone.forEach(cloneEl => this.wrapper.appendChild(cloneEl))
      contentWidth = this.wrapper.scrollWidth
    }

    this.offset = 0
    this.currentX = -this.loopWidth
  }

  pause() {
    this.isPaused = true
  }

  resume() {
    this.isPaused = false
  }

  initSlider() {
    if (this.slider) return

    this.slider = new Swiper(this.el, {
      modules: [FreeMode],
      slidesPerView: 'auto',
      freeMode: {
        enabled: true
      },
      allowTouchMove: false
    })
  }

  animate() {
    if (!this.isPaused) {
      const delta = this.speed
      this.offset = (this.offset + delta) % this.loopWidth
      this.currentX = this.reverse
        ? -this.loopWidth + this.offset
        : -this.loopWidth - this.offset
      this.applyTransform()
    }

    this.raf = requestAnimationFrame(() => this.animate())
  }

  destroy() {
    if (this.raf) cancelAnimationFrame(this.raf)
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }
    window.removeEventListener('resize', this.onResize)
  }

  rebuild() {
    if (!this.originalSlides.length) return
    if (this.raf) cancelAnimationFrame(this.raf)
    this.cloneSlides()
    if (this.slider) this.slider.update()
    this.applyTransform()
    this.animate()
  }

  onResize() {
    this.rebuild()
  }

  bindImagesLoad() {
    const images = Array.from(this.el.querySelectorAll('img'))
    if (!images.length) return

    let pending = images.length
    const done = () => {
      pending -= 1
      if (pending === 0) this.rebuild()
    }

    images.forEach(img => {
      if (img.complete) {
        done()
      } else {
        img.addEventListener('load', done, { once: true })
        img.addEventListener('error', done, { once: true })
      }
    })
  }

  applyTransform() {
    this.wrapper.style.transform = `translate3d(${this.currentX}px, 0, 0)`
  }
}
